import { useEffect, useRef } from "react";

const useInactivity = (onTimeout, timeout = 30 * 1000) => {
    const timeoutRef = useRef(null);
    const referenciaTimeoutInicial = useRef(null);

    const updateLastActivity = () => {
        const now = Date.now();
        localStorage.setItem("lastActivity", now.toString());
    };
    
    const handleTimeout = () => {
        localStorage.removeItem("lastActivity");
        onTimeout();
    };

    const checkGlobalInactivity = () => {
        if (!timeout) return;
        
        const lastActivityStr = localStorage.getItem("lastActivity");
        if (!lastActivityStr) {
            return false;
        }
        const lastActivity = parseInt(lastActivityStr, 10);
        const now = Date.now();

        if (now - lastActivity > timeout) {
            handleTimeout();
            return true;
        }
        return false
    };

    useEffect(() => {
        if (!timeout) return;

        const activityHandler = () => updateLastActivity();

        window.addEventListener("mousemove", activityHandler);
        window.addEventListener("keydown", activityHandler);
        window.addEventListener("click", activityHandler);
        window.addEventListener("scroll", activityHandler);

        const wasInactive = checkGlobalInactivity();
        
        // Solo si NO estaba inactivo, inicializar el timestamp tras un pequeño delay
        if (!wasInactive) {
            referenciaTimeoutInicial.current = setTimeout(() => {
                updateLastActivity();
            }, 1000);
        }

        timeoutRef.current = setInterval(checkGlobalInactivity, 1000);

        return () => {
            window.removeEventListener("mousemove", activityHandler);
            window.removeEventListener("keydown", activityHandler);
            window.removeEventListener("click", activityHandler);
            window.removeEventListener("scroll", activityHandler);
            
            if (timeoutRef.current) {
                clearInterval(timeoutRef.current);
                clearTimeout(referenciaTimeoutInicial.current);
            }
        };
    }, [timeout, onTimeout]);
};

export default useInactivity;
